import React, { useEffect, useState } from 'react';
import { contentService, SiteContent } from '../services/content';

interface ContentPageProps {
  sectionKey: string;
  defaultTitle: string;
}

const ContentPage: React.FC<ContentPageProps> = ({ sectionKey, defaultTitle }) => {
  const [content, setContent] = useState<SiteContent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await contentService.get(sectionKey);
        setContent(data);
      } catch (err: any) {
        if (err.response && err.response.status === 404) {
          setError(`El contenido de "${defaultTitle}" aún no ha sido publicado.`);
        } else {
          setError(`Error al cargar el contenido de "${defaultTitle}".`);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [sectionKey, defaultTitle]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center pt-[72px]">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-gray-200 border-t-gray-900 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 pt-[96px]">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-8 md:p-12">
          <h1 className="text-3xl font-serif font-bold text-gray-900 mb-8 text-center">
            {content?.title || defaultTitle}
          </h1>
          
          {error ? (
            <div className="text-center py-12">
              <p className="text-gray-500">{error}</p>
            </div>
          ) : (
            <div className="prose prose-lg max-w-none text-gray-700 whitespace-pre-wrap">
              {content?.content}
            </div>
          )}
          
          {content?.updated_at && (
            <div className="mt-12 pt-6 border-t border-gray-100 text-sm text-gray-500 text-center">
              Última actualización: {new Date(content.updated_at).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentPage;
